<template>
  <label class="app-checkbox">
    <input
      type="checkbox"
      @change="change"
      v-bind="$attrs"
      :checked="checked"
    />
    <span></span>
    <div v-if="label" v-html="label"></div>
  </label>
</template>

<script>
export default {
  props: [
    'value',
    'label'
  ],
  data() {
    return {
      checked: this.value
    }
  },
  updated() {
    this.checked = this.$props.value
  },
  methods: {
    change() {
      this.checked = !this.checked
      this.$emit('input', this.checked)
    }
  }
}
</script>

<style lang="scss" scoped>
.app-checkbox {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}

.app-checkbox input[type="checkbox"] {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.app-checkbox span {
  width: 24px;
  height: 24px;
  border: 2px solid #ced4da;
  background-color: white;
  border-radius: 4px;
  margin-right: 10px;
  display: inline-block;
  position: relative;
}

.app-checkbox input[type="checkbox"]:checked + span {
  background-color: rgb(36 137 197);
  border: 2px solid rgb(36 137 197);
}

.app-checkbox input[type="checkbox"]:checked + span::after {
  content: '\2714';
  position: absolute;
  left: 3px;
  top: -2px;
  color: white;
  font-size: 17px;

  //content: '';
  //position: absolute;
  //top: 2px;
  //left: 8px;
  //width: 6px;
  //height: 12px;
  //border: solid white;
  //border-width: 0 2px 2px 0;
  //transform: rotate(45deg);
}
</style>